define([
  "backbone",
  "marionette",
  "jquery",
  "underscore",
  "messaging/messenger",
  "./taskLocalesView",
], function (Backbone, Marionnete, $, _, Messenger, TaskLocalesView) {
  "use strict";

  var ALL_LANGUAGES_ID = -1;

  var TaskLocalesController = Marionnete.Controller.extend({
    initialize: function (options) {
      this.region = options.region;
      this.name = "taskLocales";
    },
    show: function (task) {
      this.task = task;
      var languages = Messenger.reqres.request("kb:languages");
      var languagesWithAll = new Backbone.Collection([
        {
          id: ALL_LANGUAGES_ID,
          name: $.t("task.wizard.allLocales"),
        },
      ]);
      languagesWithAll.add(languages.toJSON({ saving: true }), { parse: true });
      this.collection = new Backbone.Collection(
        _.map(task.get("languageIds"), function (languageId) {
          var language = languages.get(languageId);
          return new Backbone.Model({
            id: languageId,
            name: language.get("name"),
          });
        }),
      );
      this.collection.languages = languagesWithAll;
      this.view = new TaskLocalesView.localesView({ collection: this.collection });
      this.view.on("add:locales", this._onAddLocales, this);
      this.view.on("remove:allLocales", this._onRemoveAllLocales, this);
      this.view.on("itemview:remove:locale", this._onRemoveLocale, this);
      this.showRegion(this.view);
    },
    commitData: function () {
      var languageIds = this.collection.map(function (language) {
        return language.get("id");
      });
      this.task.set("languageIds", languageIds);
      return true;
    },
    isEmpty: function () {
      return this.collection.length === 0;
    },
    _onAddLocales: function () {
      var languageIds = this.view.getSelectedLocales();
      if (!languageIds || !languageIds.length) {
        return;
      }
      var languages = this.task.languages;
      if (languageIds[0] === ALL_LANGUAGES_ID) {
        languages.each(function (language) {
          var model = this.collection.get(language.id);
          if (!model) {
            this.collection.add(
              new Backbone.Model({
                id: language.id,
                name: language.get("name"),
              }),
            );
          }
        }, this);
      } else {
        _.each(
          languageIds,
          function (languageId) {
            var language = languages.get(languageId);
            var model = this.collection.get(languageId);
            if (!model) {
              this.collection.add(
                new Backbone.Model({
                  id: language.id,
                  name: language.get("name"),
                }),
              );
            }
          },
          this,
        );
      }
    },
    _onRemoveLocale: function (itemView) {
      var model = itemView.model;
      this.collection.remove(model);
      this._removeStepsForLocale(model.id);
    },
    _onRemoveAllLocales: function () {
      this.collection.forEach(function (model) {
        this._removeStepsForLocale(model.id);
      }, this);
      this.collection.reset([]);
    },
    _removeStepsForLocale: function (languageId) {
      var stepsToRemove = [];
      this.task.steps().each(function (step) {
        if (step.get("languageId") == languageId) {
          stepsToRemove.push(step);
        }
      });
      this.task.steps().remove(stepsToRemove);
    },
  });

  return TaskLocalesController;
});
